export const JAVASCRIPT_ACTIONS = [
  {
    custom: true,
    icon: 'curly-brackets',
    action: 'js-beautify',
    tooltip: 'format code',
    color: 'primary',
    aria: 'format code',
    testId: 'js-beautify'
  },
];
